import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { UAParser } from 'ua-parser-js'
import server from 'server/serverController2'
import styled from 'styled-components'
import { useCookies } from 'react-cookie'

import CenterModal from 'components/presenters/modal/CenterModal'
import SocialLogin from 'components/presenters/login/SocialLogin'
import TitleHeader from 'components/presenters/header/TitleHeader'
import { useHistory } from 'react-router-dom'
import { sendWebViewMsg } from 'utils/bridge'
import { UserInfoActions, UserPermissionActions } from 'store/actionCreators'
import { getQueryStringObject } from 'utils/utils'
import useCreateOnboardingTodoMutate from 'hooks/queries/task/useCreateOnboardingTodoMutate'

export default function SocialLoginContainer({ onSignupReq, isOnboarding = false }) {
  const [cookies, setCookie, removeCookie] = useCookies()

  const userInfo = useSelector((state) => {
    return state.userInfo
  })

  const history = useHistory()
  const queryString = getQueryStringObject()
  const redirectPath = queryString['redirect_path']

  const [showIOSSignup, setShowIOSSignup] = useState(false)
  const [showAppStore, setShowAppStore] = useState(false)

  const [userInfoSetted, setUserInfoSetted] = useState(false)

  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false)
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)

  const { mutateAsync: createOnboardingTodo } = useCreateOnboardingTodoMutate()

  //Init Center Modal State
  useEffect(() => {
    if (initCenterModal === true) {
      setCenterModalVisible(false)
      setCenterModalDataList({})
      setOnModalComplete(null)
      setOnModalCancel(null)
      setInitCenterModal(false)
    }
  }, [initCenterModal])

  useEffect(() => {
    let parserObj = new UAParser()
    const OSInfo = parserObj.getOS()
    if (!userInfo?.isApp) {
      setShowAppStore(true)
    } else if (OSInfo['name'] === 'iOS') {
      setShowIOSSignup(true)
    }
    if (userInfo.isLogin && userInfoSetted === true) {
      if (redirectPath) {
        history.replace(redirectPath)
        return
      }
      history.replace('/')
    }
  }, [history, redirectPath, userInfo?.isApp, userInfo.isLogin, userInfoSetted])

  // useEffect(() => {
  //   //login
  //   if (userInfoSetted === true) {
  //     console.log('login start')
  //     console.log(redirectPath)
  //     if (redirectPath && redirectPath.length > 0) {
  //       // history.push(redirectPath);
  //       history.push(`/write/personal?redirect_path=${redirectPath}`)
  //     } else {
  //       history.push('/write/personal?redirect_path=/')
  //     }
  //   }
  // }, [history, redirectPath, userInfoSetted])

  const handlePressAppStore = () => {
    const currLink =
      process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'qa'
        ? 'https://qa.motiners.com'
        : 'https://motiners.com'
    window.location.href = `https://plink.motiners.com/?link=${currLink}&apn=com.motiners.bundle&isi=1556370860&ibi=com.motiners.motinersapp`
  }

  const handlePressAppleLogin = async () => {
    const res = await sendWebViewMsg({ action: 'REQ_APPLE_LOGIN' }).catch((err) => {
      const errData = err.error.res_data
      if (errData.detail_code === 'FAILED_TO_PROCESS_APPLE_LOGIN') {
        setCenterModalVisible(true)
        setCenterModalDataList({ description: '애플 로그인에 실패했어요. 다시 시도해주세요.' })
        setOnModalComplete(() => () => {
          setInitCenterModal(true)
        })
      }
    })

    if (res.success !== 1) {
      //terminate
      return
    }
    console.log('res')
    console.log(res)
    const authorizationCode = res.data.auth_code
    const email = res.data.email

    const form = {}
    form['code'] = authorizationCode
    if (email) {
      form['email'] = email
    }

    const response = await server.postRequestData('auth/apple/login', form)

    if (response.success === 1) {
      const userData = response.data.user
      const permissionData = response.data.permissions

      if (userData) {
        UserInfoActions.updateUserState({
          name: userData.nickname,
          email: userData.email,
          id: userData.no,
          isLogin: true,
          achievement_goal: userData.achievement_goal,
          profile_img: userData.profile_img,
          exp_point: userData.exp_point,
        })
        UserInfoActions.updateRole({
          role: userData.role,
        })
      }

      if (permissionData) {
        UserPermissionActions.updateUserPermission({ matching: permissionData['matching'] })
      }

      if (
        cookies['onboarding_habit'] &&
        cookies['onboarding_description'] !== undefined &&
        cookies['onboarding_original_image_name'] &&
        cookies['onboarding_original_image_path'] &&
        cookies['onboarding_merged_image_name'] &&
        cookies['onboarding_merged_image_path']
      ) {
        try {
          await createOnboardingTodo({
            onboardingType: cookies['onboarding_habit'],
            description: cookies['onboarding_description'],
            originalImageName: cookies['onboarding_original_image_name'],
            originalImagePath: cookies['onboarding_original_image_path'],
            mergedImageName: cookies['onboarding_merged_image_name'],
            mergedImagePath: cookies['onboarding_merged_image_path'],
          })

          removeCookie('onboarding_habit', { path: '/' })
          removeCookie('onboarding_description', { path: '/' })
          removeCookie('onboarding_original_image_name', { path: '/' })
          removeCookie('onboarding_original_image_path', { path: '/' })
          removeCookie('onboarding_merged_image_name', { path: '/' })
          removeCookie('onboarding_merged_image_path', { path: '/' })
        } catch (e) {
          setCenterModalVisible(true)
          setCenterModalDataList({
            description: '3일 챌린지 인증기록을 저장하지 못했어요.\n카카오로 문의 주시면 해결해 드릴게요.',
            confirmTxt: '문의하기',
          })
          setOnModalComplete(() => () => {
            setInitCenterModal(true)
            window.open('https://pf.kakao.com/_gmtJs/chat', '_blank')
          })
          setOnModalCancel(()=> () => {
            setInitCenterModal(true)
          })
          return
        }
      }

      setUserInfoSetted(true)
      setCookie('is_onboarding_completed', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 })
      sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })
      return
    }

    let authToken = null
    const errData = response.error.res_data
    if (errData.detail_code === 'SOCIAL_DATA_DOES_NOT_EXIST') {
      authToken = errData.auth_token
    } else {
      setCenterModalVisible(true)
      setCenterModalDataList({
        description: '애플 로그인에 실패했어요.\n admin@unitmi.com 으로 문의해주세요.',
      })
      setOnModalComplete(() => () => {
        setInitCenterModal(true)
      })
      return
    }

    if (onSignupReq) {
      const signupData = {}
      signupData['email'] = email
      signupData['auth_token'] = authToken
      signupData['type'] = 'apple'
      onSignupReq(signupData)
    }
  }

  const handlePressKakaoLogin = async () => {
    try {
      const res = await sendWebViewMsg({ action: 'REQ_KAKAO_LOGIN' })

      if (res.success === 0) {
        return
      }

      const accessToken = res.data.token.accessToken

      let form = {
        access_token: accessToken,
      }
      let response = await server.postRequestData(`auth/kakao/login`, form)

      let authToken = null

      //Login
      if (response.success === 1) {
        const userData = response.data.user
        const permissionData = response.data.permissions

        if (userData) {
          UserInfoActions.updateUserState({
            name: userData.nickname,
            email: userData.email,
            id: userData.no,
            isLogin: true,
            achievement_goal: userData.achievement_goal,
            profile_img: userData.profile_img,
            exp_point: userData.exp_point,
          })
          UserInfoActions.updateRole({
            role: userData.role,
          })
        }

        if (permissionData) {
          UserPermissionActions.updateUserPermission({ matching: permissionData['matching'] })
        }

        if (
          isOnboarding &&
          cookies['onboarding_habit'] &&
          cookies['onboarding_description'] !== undefined &&
          cookies['onboarding_original_image_name'] &&
          cookies['onboarding_original_image_path'] &&
          cookies['onboarding_merged_image_name'] &&
          cookies['onboarding_merged_image_path']
        ) {
          try {
            await createOnboardingTodo({
              onboardingType: cookies['onboarding_habit'],
              description: cookies['onboarding_description'],
              originalImageName: cookies['onboarding_original_image_name'],
              originalImagePath: cookies['onboarding_original_image_path'],
              mergedImageName: cookies['onboarding_merged_image_name'],
              mergedImagePath: cookies['onboarding_merged_image_path'],
            })

            removeCookie('onboarding_habit', { path: '/' })
            removeCookie('onboarding_description', { path: '/' })
            removeCookie('onboarding_original_image_name', { path: '/' })
            removeCookie('onboarding_original_image_path', { path: '/' })
            removeCookie('onboarding_merged_image_name', { path: '/' })
            removeCookie('onboarding_merged_image_path', { path: '/' })
          } catch (e) {
            setCenterModalVisible(true)
            setCenterModalDataList({
              description: '3일 챌린지 인증기록을 저장하지 못했어요.\n카카오로 문의 주시면 해결해 드릴게요.',
              confirmTxt: '문의하기',
            })
            setOnModalComplete(() => () => {
              setInitCenterModal(true)
              window.open('https://pf.kakao.com/_gmtJs/chat', '_blank')
            })
            setOnModalCancel(()=> () => {
              setInitCenterModal(true)
            })
            return
          }
        }

        setUserInfoSetted(true)
        setCookie('is_onboarding_completed', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 })
        sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })
        return
      } else {
        const errData = response.error.res_data
        //Signup
        if (errData['detail_code'] === 'SOCIAL_DATA_NOT_EXIST') {
          authToken = errData['auth_token']
        } else {
          //error fail to login
          setCenterModalVisible(true)
          setCenterModalDataList({
            description: '카카오 로그인에 실패했어요.\n admin@unitmi.com 으로 문의해주세요.',
          })
          setOnModalComplete(() => () => {
            setInitCenterModal(true)
          })
          return
        }
      }

      //If Login Data Not Exist, Continue with Signup
      const receivedProfile = res.data.profile
      const email = receivedProfile.email

      //TODO : If Email already Exist, Ask Connect to existing account

      let phone = null
      if (receivedProfile?.phoneNumber?.startsWith('+82 1')) {
        phone = receivedProfile.phoneNumber.replaceAll('+82 ', '0').replaceAll('-', '')
      }

      let gender = null
      if (receivedProfile?.gender.toUpperCase() === 'MALE') {
        gender = 'm'
      } else if (receivedProfile?.gender.toUpperCase() === 'FEMALE') {
        gender = 'f'
      }

      let birth = null
      if (
        !['null', null, undefined].includes(receivedProfile?.birthyear) &&
        !['null', null, undefined].includes(receivedProfile?.birthday)
      ) {
        birth =
          receivedProfile.birthyear +
          '-' +
          receivedProfile.birthday.slice(0, 2) +
          '-' +
          receivedProfile.birthday.slice(2)
      }

      if (onSignupReq) {
        const signupData = {}
        signupData['auth_token'] = authToken
        signupData['email'] = !['null', null, undefined].includes(email) ? email : null
        signupData['sex'] = !['null', null, undefined].includes(gender) ? gender : null
        signupData['nickname'] = null
        signupData['phone'] = !['null', null, undefined].includes(phone) ? phone : null
        signupData['birth'] = !['null', null, undefined].includes(birth) ? birth : null
        signupData['type'] = 'kakao'

        onSignupReq(signupData)
      }
    } catch (err) {
      if (err?.error?.res_data) {
        const errData = err.error.res_data
        if (errData.detail_code === 'FAILED_TO_PROCESS_KAKAO_LOGIN') {
          setCenterModalVisible(true)
          setCenterModalDataList({ description: '카카오 로그인에 실패했어요. 다시 시도해주세요.' })
          setOnModalComplete(() => () => {
            setInitCenterModal(true)
          })
        }
      }
    }
  }

  return (
    <SocialLoginBlock>
      {!isOnboarding && <TitleHeader background={'transparent'} />}
      <SocialLogin
        redirectPath={redirectPath}
        showIOSSignup={showIOSSignup}
        showAppStore={showAppStore}
        onPressAppleLogin={handlePressAppleLogin}
        onPressKakaoLogin={handlePressKakaoLogin}
        onPressAppStore={handlePressAppStore}
        isOnboarding={isOnboarding}
      />
      <CenterModal
        modalVisible={centerModalVisible}
        setModalVisible={setCenterModalVisible}
        dataList={centerModalDataList}
        onCancel={onModalCancel}
        onComplete={onModalComplete}
      />
    </SocialLoginBlock>
  )
}

const SocialLoginBlock = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
